import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
* {
  padding: 0;
  box-sizing: border-box;
  margin: 0;
  font-family: 'Poppins', sans-serif;
}

html,body {
  margin: auto;
  overflow-x: hidden;
}

li, a, button {
    cursor: pointer;
    text-decoration: none;
  list-style: none;
  white-space: nowrap;

  :focus {
      outline: none;
  }

}

h1,h2,h3,h4,h5,p {
    white-space: nowrap;

}

div {
    position: relative;
}


`;

export default GlobalStyle;
